import type { AuthorCardProps } from "@op/puck-types";
import { Dc_Card_Person } from "@op/sf-op";
import Medium from "../../../../../components/puck/Medium/Medium";

const AuthorCard = ({
  isMarginal,
  authorName,
  position,
  medium,
  children,
  profileUrl,
}: AuthorCardProps) => {
  return (
    <Dc_Card_Person
      style={{
        breakInside: "avoid-page",
      }}
      name={authorName}
      subtext={position}
      imageSlot={medium && <Medium medium={medium} cover />}
      isMarginal={isMarginal}
      isPrint={true}
      buttonSlot={
        profileUrl && (
          <a href={profileUrl} target="_blank" rel="noopener noreferrer">
            <Dc_Card_Person.ProfileButton>
              Go to Profile
            </Dc_Card_Person.ProfileButton>
          </a>
        )
      }
    >
      {children}
    </Dc_Card_Person>
  );
};

export default AuthorCard;
